import React, { CSSProperties, ReactNode } from 'react';

type ListProps = {
  children: ReactNode;
  tagName?: string;
  className?: string;
  style?: CSSProperties;
};

const baseStyle: CSSProperties = { listStyle: 'none', padding: 0, margin: 0 };

export const List = ({ children, tagName = 'ul', className, style }: ListProps) => {
  const Tag = tagName as any;
  const isNative = tagName === 'ul' || tagName === 'ol' || tagName === 'dl';

  return (
    <Tag
      className={className}
      style={isNative ? { ...baseStyle, ...style } : style}
      role={!isNative ? 'list' : undefined}
    >
      {children}
    </Tag>
  );
};
